module.exports = __webpack_public_path__ + "img/beer_id-113.aea92430.png";